import { action } from 'satcheljs';
import ReadWriteRecipientWellViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientWellViewState';

export default action(
    'ONE_RECIPIENT_SELECTED_ACTION',
    (recipientWell: ReadWriteRecipientWellViewState) => {
        return {
            recipientWell,
        };
    }
);
